import { customer } from "$lib/state/customer";
import { cart } from "$lib/state/cart";
import { cartTotals } from "$lib/state/cartTotals";

/**
 * @param {string} action
 * @param {FormData} formData
 * @param {string} recaptcha
 */
export async function fetchCustomerSignin(action, formData, recaptcha) {
  
  const res = await fetch(/** @type {string} */ (action), {
    method: "POST",
    headers: {
      "X-ReCaptcha": recaptcha,
    },
    body: formData,
  });
  const response = await res.json();

  if (res.status == 200) {
    customer.set(response.magentoCustomer);
    cart.set(response.customerCart);
    cartTotals.set(response.cartTotals);
  
    return true;
  }

  throw new Error(response.message);
}
